const Translations = {
  english: {
    title: 'Most Popular',
  },
  french: {
    title: 'Contenus les plus consultés',
  },
  arabic: {
    title: 'الأكثر مشاهدة',
  },
  hebrew: {
    title: 'הכתבות הנצפות ביותר',
  },
  persian: {
    title: 'محبوب ترین',
  },
}

export default Translations
